
const metaGridConfig = [
  { header: "Descrição", field: "descricao" },
  { header: "Data Inicial", field: "dataInicial" },
  { header: "Data Final", field: "dataFinal" }
];

export default metaGridConfig;